// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o4Qn","colMin":"styles_colMin__Li2mO"};